export default __webpack_public_path__ + "static/media/CarImages.KigerGallery5.2c069725.jpg";